import React from 'react';
import ShowEntityData from '../../../../Elements/ShowEntityData';
import TpCreditMemoService from '../../../../Services/CreditMemo/TpCreditMemoService';
import TpCreditMemoItem from '../../../../Domain/CreditMemo/TpCreditMemoItem';

export default class TpCreditMemoDetailsInfoTab extends React.Component {
  static defaultProps = {
    tpCreditMemoId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {}

  render() {
    return (
      <ShowEntityData
        itemId={this.props.tpCreditMemoId}
        type={TpCreditMemoItem}
        serviceGetByIdFunction={TpCreditMemoService.GetById}
      />
    );
  }
}
